/* Global imports. */
import React from "react";
import { Link } from "gatsby"

import { KontentEvent } from "@models/kontent";

import iconLocation from "@images/icon--location.svg"
import iconDate from "@images/icon--date.svg";

interface Props {
  event: KontentEvent
}

const EventCard = ({ event }: Props) => {
  const formatEventDateTime = (event: { start_date_time: { value: string }, end_date_time: { value: string } }) => {
    let formattedDateTime;
  
    const startDateTime = new Date(event.start_date_time.value);
    const endDateTime = new Date(event.end_date_time.value);
  
    const startDate = startDateTime.toLocaleDateString();
    const startTime = startDateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const endDate = endDateTime.toLocaleDateString();
    const endTime = endDateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  
    if (startDate === endDate) {
      formattedDateTime = `${startDate}, ${startTime} - ${endTime}`;
    } else {
      const formattedStartDateTime = startTime !== "00:00" ? `${startTime} ${startDate}` : startDate;
      const formattedEndDateTime = endTime !== "00:00" ? `${endTime} ${endDate}` : endDate;
  
      formattedDateTime = `${formattedStartDateTime} to ${formattedEndDateTime}`;
    }
  
    return formattedDateTime;
  };


  return (
    <li className="w-full col-span-12 mb-4 p-8 overflow-hidden list-none transition-colors duration-500 bg-white rounded-lg shadow-xl border border-red group hover:bg-red last:mb-0 group">
      <figure>
        <Link to={`/events/${event.url_slug.value}`}> 
          <h3 className="text-[24px] mb-8 group-hover:!text-white">{event.title.value}</h3>
          <div className="mb-6 grid grid-cols-1">
            <div className="relative px-8 group-hover:!text-white leading-8">
              <span className="absolute top-0 left-0 block w-4 h-4">
              <img src={iconLocation} alt="" className="h-[28px] w-[28px]" />
              </span>
              {event.physical_online.value[0] && event.physical_online.value[0].codename === "online" ? "Online" : event.location_name.value}
            </div>
            <div className="relative px-8 group-hover:!text-white leading-8">
              <span className="absolute top-0 left-0 block w-4 h-4 ">
              <img src={iconDate} alt="" className="h-[28px] w-[28px]" />
              </span>
              {formatEventDateTime(event)}
            </div>       
          </div>
          <p className="group-hover:!text-white">
            {event.short_description.value}
          </p>
        </Link>
      </figure>
    </li>
  )
};

export default EventCard;
